class BaseReadMore extends HTMLElement {
  static EXPANDED_CLASS = 'base-read-more--expanded';

  constructor() {
    super();

    this.description = this.querySelector('[data-base-read-more="description"]');
    this.button = this.querySelector('[data-base-read-more="toggle-button"]');
    this.readMoreText = this.dataset.baseReadMoreTextOpen || '';
    this.readLessText = this.dataset.baseReadMoreTextClose || '';

    this._debouncedCheckTruncation = (window.debounce || this._createDebounce)(
      () => this._checkTruncation(),
      150
    );
  }

  connectedCallback() {
    if (!this.description || !this.button) return;

    this.addEventListener('click', (event) => {
      if (event.target.closest('a')) return;
      this._onToggleClick();
    });

    window.addEventListener('resize', this._debouncedCheckTruncation);
    this._checkTruncation();
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this._debouncedCheckTruncation);
  }

  _createDebounce(fn, wait) {
    let t;
    return () => {
      clearTimeout(t);
      t = setTimeout(() => fn(), wait);
    };
  }

  _isMobileViewport() {
    return window.matchMedia('(max-width: 479px)').matches;
  }

  _checkTruncation() {
    if (!this._isMobileViewport()) {
      this.button.classList.add('hidden');
      this.classList.remove(BaseReadMore.EXPANDED_CLASS);
      return;
    }

    const wasExpanded = this.classList.contains(BaseReadMore.EXPANDED_CLASS);
    if (wasExpanded) return;

    const isTruncated = this.description.scrollHeight > this.description.clientHeight;
    const hasButtonContent = this.readMoreText && !/^[.\s]*$/.test(this.readMoreText);

    if (isTruncated && hasButtonContent) {
      this.button.classList.remove('hidden');
      this.button.setAttribute('aria-expanded', 'false');
      this.button.textContent = this.readMoreText;
    } else {
      this.button.classList.add('hidden');
    }
  }

  _onToggleClick() {
    if (!this._isMobileViewport()) return;

    const isExpanded = this.classList.contains(BaseReadMore.EXPANDED_CLASS);
    const isTruncated = this.description.scrollHeight > this.description.clientHeight;

    if (!isExpanded && !isTruncated) return;

    if (isExpanded) {
      this.classList.remove(BaseReadMore.EXPANDED_CLASS);
      this.button.textContent = this.readMoreText;
      this.button.setAttribute('aria-expanded', 'false');
    } else {
      this.classList.add(BaseReadMore.EXPANDED_CLASS);
      this.button.textContent = this.readLessText;
      this.button.setAttribute('aria-expanded', 'true');
    }
  }
}

if (!customElements.get('base-read-more')) {
  customElements.define('base-read-more', BaseReadMore);
}
